module.exports = __webpack_public_path__ + "static/Maher-97fa26e36884d2dcd8d5794f4e1816e7.png";